import {
  Box,
  Checkbox,
  Container,
  FormControlLabel,
  Grid,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import "./RequestQuote.css";
import { makeStyles } from "@material-ui/core/styles";
import HomeIcon from "@material-ui/icons/Home";
import AllInclusiveIcon from "@material-ui/icons/AllInclusive";
import Header from "../../Shard/Navbar/Header";
import { Link } from "react-router-dom";
import LoadingAndUnLoading from "./LoadingAndUnLoading";
import ProjectDetails from "./ProjectDetails";

const useStyles = makeStyles({
  quoteHeading: {
    display: "flex",
    justifyContent: "space-between",
    background: "#DEECFC",
    padding: "10px 20px",
    borderRadius: "10px",
    margin: "10px 0",
  },
  quoteContent: {
    padding: "10px 0px",
    borderRadius: "5px",
  },
  title: {
    paddingBottom: "0px",
  },
  requestQuoteTitle: {
    display: "flex",
    alignItems: "center",
    columnGap: "5px",
  },
  formControl: {
    minWidth: 300,
  },
  selectEmpty: {},
  quoteContainer: {
    display: "flex",
    gap: "20px",
    flexWrap: "wrap",
  },
  requestQuote1Submit: {
    width: "160px",
    height: "45px",
    marginInlineEnd: "10px",
    background: "#BE1E2D",
    color: "#fff",
    marginTop: "20px",
    fontWeight: "600",
  },
});

const ProductDetails = ({ isShaw, setIsShaw }) => {
  const classes = useStyles();
  const [loadingUnDetails, setLoadingUnDetails] = useState([1]);
  const [state, setState] = React.useState({
    Food: "",
    fullLoad: "",
    truckType: "",
    make: "",
    lessLoad: "",
    top: "",
    side: "",
    name: "hai",
  });

  const handleChange = (event) => {
    const name = event.target.name;
    setState({
      ...state,
      [name]: event.target.value,
    });
  };
  const hanldeIncrementLD = () => {
    setLoadingUnDetails((prv) => [...prv, 1]);
  };
  return (
    <div className="Request-a-Quote" style={{ paddingTop: "80px" }}>
      <Header isShaw={isShaw} setIsShaw={setIsShaw} />

      <Container>
        <Box className="product_details_text">
          <Grid container spacing={3}>
            <Grid item xs={12} lg={4} md={4}>
              <Box>
                <Typography variant="h5">Product Type</Typography>
                <Typography variant="h6">Chemical</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} lg={4} md={4}>
              <Box>
                <Typography variant="h5">Transportation Type</Typography>
                <Typography variant="h6"> FTL</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} lg={4} md={4}>
              <Box>
                <Typography variant="h5">Packaging </Typography>
                <Typography variant="h6">Bulk</Typography>
              </Box>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={4} md={4}>
              <Box>
                <Typography variant="h5">Ready to Load</Typography>
                <Typography variant="h6">30/09/2022</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} lg={4} md={4}>
              <Box>
                <Typography variant="h5">Truck Type</Typography>
                <Typography variant="h6">20 feet comtainer</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} lg={4} md={4}>
              <Box>
                <Typography variant="h5">Estimated Delivery Date </Typography>
                <Typography variant="h6">03/09/2022</Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
        <div className="requsetQuote">
          {/*Loding and Unloading Details  */}
          {loadingUnDetails.map((_, i) => (
            <LoadingAndUnLoading
              hanldeIncrementLD={hanldeIncrementLD}
              key={i}
            />
          ))}
          {/* Driver Requirements */}
          <Box>
            <Grid container spacing={1}>
              <Grid item xs={12} lg={6} md={12}>
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    columnGap: "10px",
                    paddingBottom: "15px",
                  }}
                >
                  <Typography variant="span">
                    <HomeIcon />
                  </Typography>
                  <Typography variant="h6">Driver Requirements </Typography>
                </Box>
                <Container>
                  <Box className="">
                    <Box
                      style={{
                        display: "flex",
                        columnGap: "20px",
                        alignItems: "center",
                        flexWrap: "wrap",
                      }}
                    >
                      <Box>
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={handleChange}
                              name="checkedB"
                              color="primary"
                            />
                          }
                          label="Training"
                        />
                      </Box>
                      <Box>
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={handleChange}
                              name="checkedB"
                              color="primary"
                            />
                          }
                          label="PPE"
                        />
                      </Box>
                      <Box>
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={handleChange}
                              name="checkedB"
                              color="primary"
                            />
                          }
                          label="Entry Permits"
                        />
                      </Box>
                    </Box>
                  </Box>
                </Container>
              </Grid>
              <Grid item xs={12} lg={6} md={12}></Grid>
            </Grid>
          </Box>

          {/* Product Details */}

          <ProjectDetails />

          {/* Associated Service  */}
          <Box className={classes.quoteContent}>
            <Grid container spacing={1}>
              <Grid item xs={12} lg={12} md={12}>
                <Box className="">
                  <Box>
                    <Box className={classes.title}>
                      <Typography
                        variant="h6"
                        className={classes.requestQuoteTitle}
                      >
                        <span className="ServiceIcon">
                          <AllInclusiveIcon />
                        </span>
                        <span> Associated Service</span>
                      </Typography>
                    </Box>
                  </Box>
                  <Box className="reqCheckBoxMain">
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={<Checkbox name="Loading" color="primary" />}
                        label="Insuracnce"
                      />
                    </Box>
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange}
                            name="checkedB"
                            color="primary"
                          />
                        }
                        label="Certification"
                      />
                    </Box>
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange}
                            name="checkedB"
                            color="primary"
                          />
                        }
                        label="Inspection Services"
                      />
                    </Box>
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange}
                            name="checkedB"
                            color="primary"
                          />
                        }
                        label="Custom Clearance"
                      />
                    </Box>
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange}
                            name="checkedB"
                            color="primary"
                          />
                        }
                        label="Entry Permits"
                      />
                    </Box>
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange}
                            name="checkedB"
                            color="primary"
                          />
                        }
                        label="Road ban Waiver"
                      />
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={12} lg={12} md={12}>
                <Box className="">
                  <Box className="reqCheckBoxMain">
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={<Checkbox name="Loading" color="primary" />}
                        label="Helper"
                      />
                    </Box>
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange}
                            name="checkedB"
                            color="primary"
                          />
                        }
                        label="Border Clearance"
                      />
                    </Box>
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange}
                            name="checkedB"
                            color="primary"
                          />
                        }
                        label="Steam Cleaning"
                      />
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </Grid>
            {/* Required Equipment  */}
            <Grid container spacing={1}>
              <Grid item xs={12} lg={12} md={12}>
                <Box className="">
                  <Box>
                    <Box className={classes.title}>
                      <Typography
                        variant="h6"
                        className={classes.requestQuoteTitle}
                      >
                        <span className="ServiceIcon">
                          <AllInclusiveIcon />
                        </span>
                        <span> Required Equipment</span>
                      </Typography>
                    </Box>
                  </Box>
                  <Box className="reqCheckBoxMain">
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange}
                            name="checkedB"
                            color="primary"
                          />
                        }
                        label="Liftgate"
                      />
                    </Box>
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange}
                            name="checkedB"
                            color="primary"
                          />
                        }
                        label="PalletJack"
                      />
                    </Box>
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange}
                            name="checkedB"
                            color="primary"
                          />
                        }
                        label="Load Straps"
                      />
                    </Box>
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange}
                            name="checkedB"
                            color="primary"
                          />
                        }
                        label="Load bars"
                      />
                    </Box>
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange}
                            name="checkedB"
                            color="primary"
                          />
                        }
                        label="TIR Cable"
                      />
                    </Box>
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange}
                            name="checkedB"
                            color="primary"
                          />
                        }
                        label="Side Loading"
                      />
                    </Box>
                  </Box>
                  <Box className="reqCheckBoxMain">
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange}
                            name="checkedB"
                            color="primary"
                          />
                        }
                        label="Pump"
                      />
                    </Box>
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange}
                            name="checkedB"
                            color="primary"
                          />
                        }
                        label="Flow Meter"
                      />
                    </Box>
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange}
                            name="checkedB"
                            color="primary"
                          />
                        }
                        label="Scully System"
                      />
                    </Box>
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange}
                            name="checkedB"
                            color="primary"
                          />
                        }
                        label="Lash Belt"
                      />
                    </Box>
                    <Box className="ReqcheckBox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange}
                            name="checkedB"
                            color="primary"
                          />
                        }
                        label="Tarpaulin"
                      />
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </Grid>
            {/* Remarks */}
            <Grid container spacing={1}>
              <Grid item xs={12} lg={8} md={12}>
                <Box className="">
                  <Box>
                    <Box className={classes.title}>
                      <Typography
                        variant="h6"
                        className={classes.requestQuoteTitle}
                      >
                        <span className="ServiceIcon">
                          <AllInclusiveIcon />
                        </span>
                        <span> Remarks</span>
                      </Typography>
                    </Box>
                    <Box className="request1Input">
                      {" "}
                      <TextField
                        id="outlined-basic"
                        label=""
                        variant="outlined"
                        className="request1Input"
                      />
                    </Box>
                    <Box className="quoteContentBtn">
                      <Link to="/">
                        <button className="common-btn common-btn1">Back</button>
                      </Link>
                      <button className="common-btn common-btn2">Submit</button>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </div>
      </Container>
    </div>
  );
};

export default ProductDetails;
